import service from '@/utils/request';
export var getChatList = function getChatList(data) {
  return service({
    url: "/xcpGameLog/chatLog",
    method: 'post',
    data: data
  });
};